import { render, staticRenderFns } from "./TableDialogColumn.vue?vue&type=template&id=608603f2&scoped=true"
import script from "./TableDialogColumn.vue?vue&type=script&lang=js"
export * from "./TableDialogColumn.vue?vue&type=script&lang=js"
import style0 from "./TableDialogColumn.vue?vue&type=style&index=0&id=608603f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608603f2",
  null
  
)

export default component.exports